export default function getMap(array, key, keyIsUnique = true) {
    const ret = {};
    array.forEach(a => {
        var _a;
        var _b;
        if (keyIsUnique) {
            ret[a[key]] = a;
        }
        else {
            (_a = ret[_b = a[key]]) !== null && _a !== void 0 ? _a : (ret[_b] = []);
            ret[a[key]].push(a);
        }
    });
    return ret;
}
